// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__nbA8P","filesListContainer":"PosDisputesFiles_filesListContainer__qQyqC","filesButton":"PosDisputesFiles_filesButton__uID74"};